import { NgModule } from "@angular/core";

import { LinkComponent } from "./link.component";

@NgModule({
  imports: [LinkComponent],
  exports: [LinkComponent],
})
export class LinkModule {}
